import { footerGroups } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-shell px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-layout-grid-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料总站</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              黑料总站资源、合集、大全、汇总与分类信息集中展示，聚合各类内容索引，用户可按分类快速浏览，节省查找时间，一站获取完整资源导航。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-background-200 px-3 py-1 font-label text-[11px] text-foreground-700">
                索引 12,800+
              </span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 font-label text-[11px] text-secondary-900">
                36 个分类
              </span>
              <span className="rounded-full bg-accent-100 px-3 py-1 font-label text-[11px] text-accent-900">
                每日更新
              </span>
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title} className="md:col-span-2 lg:col-span-2">
              <h4 className="font-label text-[12px] uppercase tracking-[0.2em] text-foreground-500">
                {group.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-700"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-foreground-500">
            © 2026 黑料总站 · 本站为静态分类索引展示，内容按分类汇总整理
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#summary" className="cursor-pointer text-xs text-foreground-500 hover:text-primary-700">
              分类汇总
            </a>
            <a href="#ranking" className="cursor-pointer text-xs text-foreground-500 hover:text-primary-700">
              热度榜
            </a>
            <a href="#faq" className="cursor-pointer text-xs text-foreground-500 hover:text-primary-700">
              使用帮助
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}